import React from 'react'

const MapMarkerIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 1.5C11.4825 1.5 13.5 3.495 13.5 5.9625C13.5 9.3075 9 14.25 9 14.25C9 14.25 4.5 9.3075 4.5 5.9625C4.5 3.495 6.5175 1.5 9 1.5ZM9 4.5C8.60218 4.5 8.22064 4.65804 7.93934 4.93934C7.65804 5.22064 7.5 5.60218 7.5 6C7.5 6.39782 7.65804 6.77936 7.93934 7.06066C8.22064 7.34196 8.60218 7.5 9 7.5C9.39782 7.5 9.77936 7.34196 10.0607 7.06066C10.342 6.77936 10.5 6.39782 10.5 6C10.5 5.60218 10.342 5.22064 10.0607 4.93934C9.77936 4.65804 9.39782 4.5 9 4.5ZM15 14.25C15 15.9075 12.315 17.25 9 17.25C5.685 17.25 3 15.9075 3 14.25C3 13.2825 3.915 12.42 5.3325 11.8725L5.8125 12.555C5.0025 12.8925 4.5 13.3575 4.5 13.875C4.5 14.91 6.5175 15.75 9 15.75C11.4825 15.75 13.5 14.91 13.5 13.875C13.5 13.3575 12.9975 12.8925 12.1875 12.555L12.6675 11.8725C14.085 12.42 15 13.2825 15 14.25Z" fill="white" />
        </svg>

    )
}

export default MapMarkerIcon